import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { Observable } from "rxjs";

import { environment } from "environments/environment";
import { Group } from "./group.model";
import { GroupMapper } from "./group.mapper";

@Injectable()
export class GroupRepository {
  protected http = inject(HttpClient);

  public list(): Observable<Group[]> {
    return this.http
      .get<object[]>(`${environment.apiUrl}/group/list`, {})
      .pipe(map((response) => response.map(GroupMapper.map)));
  }
}
